module.exports = __webpack_public_path__ + "img/54.646fd87b.jpg";